import React, { useState, useRef, useEffect } from 'react';
import student from "./AvatarTest.png";
import fiveStars from "./fiveStars.png";
import seeMoreIcon from "./seeMoreIcon.svg";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"
import letterE from "./letterE.png";
import letterF from "./letterF.png";
import letterL from "./letterL.png";
import letterI from "./letterI.png";
import letterR from "./letterR.png";
import letterS from "./letterS.png";
import letterY from "./letterY.png";
import letterP from "./letterP.png";
import letterN from "./letterN.png";
import letterT from "./letterN.png";

function Rectangle({ avatar, name, review, stars }) {
    return (
        <div className="rounded-2xl flex flex-col shadow-md bg-white p-6 gap-4 hover:shadow-lg transition-all duration-300 border border-gray-100 flex-shrink-0 w-full sm:w-96">
            <div className='flex items-start gap-4'>
                <img src={avatar} alt='student' className='w-[50px] h-[50px] rounded-full flex-shrink-0 object-cover' />
                <div className='flex-1 min-w-0'>
                    <h3 className='font-bold text-dk-purple text-base mb-1'>{name}</h3>
                    <img src={stars} alt='stars' className='w-[100px]' />
                </div>
            </div>
            <p className='text-sm text-gray-700 leading-relaxed line-clamp-4'>{review}</p>
        </div>
    )
}

function Testemonials() {
    const baseReviewData = [
        {
            stars: fiveStars,
            avatar: letterE,
            name: 'Elvis Lima Neves',
            review: 'Ótimas explicações, ótima didática, lições práticas e com bons exemplos, a dicção da professora é fantástica facilitando o entendimento na hora de repetir as frases ou uma palavra, fora que a professora da uns toques de ferramentas para estudo incríveis, parabéns professora, recomendo total.',
        },
        {
            stars: fiveStars,
            avatar: letterP,
            name: 'Paulo Cesar da Silva Alcantara',
            review: 'O Curso é perfeito, fornece todos os requisitos necessários para o aprendizado do inglês. Fornece material escrito, trabalha pronúncia e audição. Dicas excelentes e os Flashcards é muito bom para a consolidação do conhecimento da língua.',
        },
        {
            stars: fiveStars,
            avatar: letterY,
            name: 'Yuri Miranda Boechat',
            review: 'Olha, além da didática excelente, a organização da Lane é admirável. Tudo extremamente explicado, tudo organizado passo a passo, seguindo uma ordem lógica e cativante. Nota 10 para este curso.',
        },
        {
            stars: fiveStars,
            avatar: letterT,
            name: 'Thais Luana Consoni Costa',
            review: 'Achei o curso maravilhoso. Didática, conteúdo, vídeos, slides, explicações... Tudo muito bom e de forma simples. Recomendo, nota !!!.',
        },
        {
            stars: fiveStars,
            avatar: letterF,
            name: 'Fernando Damasceno',
            review: 'A Lane é fascinante! A didática dela é única e as aulas dela são de muito fácil entendimento. Ela consegue nos ensinar todo o inglês de maneira extremamente simples, objetiva e descomplicada.',
        },
        {
            stars: fiveStars,
            avatar: letterR,
            name: 'Rui Rodrigues 4.9',
            review: 'É um ótimo curso para quem quer iniciar os estudos na língua inglesa. A prof Lane explica muito bem,o que eu não aprendi em anos de escola, em 15 minutinhos(ou menos) aprendi nas aulas deste curso. Super recomendo! Super cool!!',
        },
        {
            stars: fiveStars,
            avatar: letterS,
            name: 'Samuel Nunes Martins',
            review: 'Estou gostando bastante da didática da professora, claramente tem experiência no que faz e guia muito bem as aulas e lições. Nota 10.',
        },
        {
            stars: fiveStars,
            avatar: letterN,
            name: 'Nilseia Ribeiro Teixeira',
            review: 'Curso maravilhoso e com exercícios. O professor tem domínio sobre o assunto e as aulas são muito bem explicadas. Valeu apena o investimento!',
        },
        {
            stars: fiveStars,
            avatar: letterL,
            name: 'Lucas Rodrigues Freitas',
            review: 'Sim, o curso é o que eu esperava! na verdade até superou minhas expectativas. Eu jpa tinha feito um curso de inglês antes, mas fiquei muito tempo sem praticar e esse curso tem me ajudado! parabéns a professora Lane, por contribuir para o aprendizado de inglês no Brasil',
        },
        {
            stars: fiveStars,
            avatar: letterE,
            name: 'Elio Elio Alves',
            review: 'Estou adorando, a professora é muito organizada e estou adorando as propostas de atividades e de organização de estudo.',
        },
        {
            stars: fiveStars,
            avatar: letterI,
            name: 'Isabelle Cristina Dias Arena',
            review: 'Essas dicas de sites e cards para estudar foram MARAVILHOSAS! Eu nunca tinha ouvido falar e fiquei mega ansiosa para usar todas!',
        },
        {
            stars: fiveStars,
            avatar: letterF,
            name: 'Flavio Travincas',
            review: 'Até o momento é bem cativante. Vejo que o curso vai ser bem interessante. Epero aproveitar bastante, pois farei mais até meu objetivo ser atingido.',
        },
    ];

    // Create infinite carousel by duplicating reviews
    const reviewData = [...baseReviewData, ...baseReviewData, ...baseReviewData];

    const scrollContainerRef = useRef(null);
    const [isHovering, setIsHovering] = useState(false);
    const autoScrollIntervalRef = useRef(null);

    const scroll = (direction) => {
        if (scrollContainerRef.current) {
            const scrollAmount = 400;
            const container = scrollContainerRef.current;
            const maxScroll = container.scrollWidth - container.clientWidth;
            let newScrollLeft = container.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);

            // Reset to beginning when reaching the end
            if (newScrollLeft >= maxScroll - 10) {
                newScrollLeft = 0;
            } else if (newScrollLeft <= 0) {
                newScrollLeft = maxScroll;
            }

            container.scrollLeft = newScrollLeft;
        }
    };

    useEffect(() => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const scrollWidth = container.scrollWidth;
            const clientWidth = container.clientWidth;
            const maxScroll = scrollWidth - clientWidth;

            // Scroll to middle position
            container.scrollLeft = maxScroll / 3;
        }
    }, []);

    useEffect(() => {
        if (isHovering) {
            if (autoScrollIntervalRef.current) {
                clearInterval(autoScrollIntervalRef.current);
                autoScrollIntervalRef.current = null;
            }
            return;
        }

        // Auto-scroll
        autoScrollIntervalRef.current = setInterval(() => {
            if (scrollContainerRef.current) {
                const container = scrollContainerRef.current;
                const maxScroll = container.scrollWidth - container.clientWidth;
                let newScrollLeft = container.scrollLeft + 2; // Small increment for smooth motion

                // Seamless looping
                if (newScrollLeft >= maxScroll - 10) {
                    newScrollLeft = 0;
                }

                container.scrollLeft = newScrollLeft;
            }
        }, 30);

        return () => {
            if (autoScrollIntervalRef.current) {
                clearInterval(autoScrollIntervalRef.current);
            }
        };
    }, [isHovering]);

    return (
        <div className='py-12 md:py-16'>
            <div className='px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 mb-12 md:mb-16'>
                <div className='max-w-7xl mx-auto text-center'>
                    <h1 className='text-3xl md:text-4xl lg:text-5xl font-bold text-dk-purple mb-4'>
                        O que os alunos estão achando dos cursos!
                    </h1>
                    <p className='text-lg md:text-xl text-gray-600 max-w-2xl mx-auto'>
                        Veja o que nossos estudantes têm a dizer sobre a experiência de aprendizado
                    </p>
                </div>
            </div>

            <div className='relative group pb-16 md:pb-20' onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
                <div
                    ref={scrollContainerRef}
                    className='flex gap-6 overflow-x-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 pb-4 [&::-webkit-scrollbar]:hidden'
                    style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                >
                    {reviewData.map((data, index) => (
                        <Rectangle
                            key={`${data.name}-${index}`}
                            stars={data.stars}
                            avatar={data.avatar}
                            name={data.name}
                            review={data.review}
                        />
                    ))}
                </div>

                <button
                    onClick={() => scroll('left')}
                    className='absolute left-0 top-[35%] -translate-y-1/2 bg-white hover:bg-dk-purple text-dk-purple hover:text-white rounded-full p-2 shadow-lg transition-all duration-300 z-10 opacity-0 group-hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-dk-purple'
                    aria-label="Anterior"
                >
                    <FiChevronLeft size={24} />
                </button>

                <button
                    onClick={() => scroll('right')}
                    className='absolute right-0 top-[35%] -translate-y-1/2 bg-white hover:bg-dk-purple text-dk-purple hover:text-white rounded-full p-2 shadow-lg transition-all duration-300 z-10 opacity-0 group-hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-dk-purple'
                    aria-label="Próximo"
                >
                    <FiChevronRight size={24} />
                </button>
            </div>
        </div>
    )
}

export default Testemonials;